module.exports = __webpack_public_path__ + "media/images/bellevue_bg-bdd186a273ef4fb4e1f47405a28c1baa.jpg";